<template>
  <div class="dt-infowindow-box">
    <p class="dt-infowindow-title" v-if="title">{{ title }}</p>
    <div class="dt-overflow">
      <div
        class="item"
        v-for="(item, index) in itemConts"
        :key="`item_${index}`"
        :class="index % 2 === 0 ? 'bg' : ''"
        v-if="notShowKeys.indexOf(item.name) === -1 && item.name !== '名称'"
      >
        <span
          :class="{
            width4bit: isAllChinese(item.name) && item.name.length <= 4
          }"
          >{{ item.name }}</span
        >
        <span class="value" v-if="item.name === '拜访日期'">
          {{ showDate(item.cont) }}
        </span>
        <span class="value" v-else>
          {{ item.cont }}
        </span>
      </div>
      <!-- <table class="dt-infowindow-table">
        <tr v-for="(item, index) in itemConts" :key="'tr_'+index" v-if="notShowKeys.indexOf(item.name) === -1">
          <td class="field-name">
            <span :class="{ width4bit: isAllChinese(item.name) && item.name.length <= 4 }">{{item.name}}</span>
          </td>
          <td v-if="item.name === '拜访人员'">
            {{item.cont.join('、')}}
          </td>
          <td v-else-if="item.name === '拜访日期'">
            <SimpleCalendar :visitDates="item.cont"></SimpleCalendar>
          </td>
          <td v-else-if="item.cont.toString().indexOf('<br/>') === -1">{{item.cont}}</td>
          <td v-else v-html="item.cont"></td>
        </tr>
      </table> -->
    </div>
    <div class="dt-infowindow-bottom" v-if="false"></div>
  </div>
</template>
<script>
import "../assets/stylesheets/infowindow.scss";
import { isAllChinese } from "../assets/javascript/utils";
import SimpleCalendar from "./SimpleCalendar";
let notShowKeys = ["id", "lng", "lat", "uuid", "orId", "weight", "visits"];
export default {
  data() {
    return {
      itemConts: [],
      notShowKeys: notShowKeys,
      isAllChinese: isAllChinese
    };
  },
  props: ["data"],
  computed: {
    title() {
      if (this.itemConts && this.itemConts.length > 0) {
        for (let i = 0, n = this.itemConts.length; i < n; i++) {
          let item = this.itemConts[i];
          if (item.name === "name") {
            return item.cont;
          }
          if (item.name === "名称") {
            return item.cont;
          }
        }
      }
      return "";
    }
  },
  mounted() {
    this.setTable();
  },
  methods: {
    setTable: function() {
      this.itemConts = this.data;
    },
    showDate(str) {
      let date = "";
      if (str.indexOf("<br/>") >= 0) {
        let list = str.split("<br/>");
        date = `${list[1]}  |  ${list[0]}`;
      } else {
        date = str;
      }
      return date;
    }
  },
  components: {
    SimpleCalendar
  }
};
</script>
<style lang="less">
.marker-title {
  min-width: 61px;
  text-align: justify; //两端对齐
  text-justify: distribute-all-lines;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/InfowindowMarker.vue